<app-base-statistics-by-part-length
[title]="title"
[getMonthlyItemsApiMethodName]="getMonthlyItemsApiMethodName"
[getDailyItemsApiMethodName]="getDailyItemsApiMethodName"
[isShowOrganizationDropDown]="false"
[isShowUserDropDown]="false"
[doughnutChartId]="doughnutChartId"
[barChartId]="barChartId"
>
</app-base-statistics-by-part-length>
